module.exports = __webpack_public_path__ + "img/calendar.2513108f.png";